import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { useInvertedLocalize } from '../../../utils/localization';
import { certsFormattedMessage } from '../../../utils/utils';

import {
  PRIMARY_CERTIFIER,
  REVIEW_AND_SUBMIT_COMMENT,
  REVIEW_AND_SUBMIT_COMPLETED,
  REVIEW_AND_SUBMIT_NOT_COMPLETED,
  REVIEW_AND_SUBMIT_SIGNATURE,
  REVIEW_AND_SUBMIT_STEP_1,
  REVIEW_AND_SUBMIT_STEP_2,
  SECONDARY_CERTIFIER,
  SUBTITLE,
  TAB_STATUS_CONS,
  TAB_STATUS_TODO,
} from './constant';
import { invertedMessages } from './messages';

function ReviewAndSubmitSubTitle({ firstStep }) {
  const {
    reviewAndSubmit,
    tabs: { tabData },
  } = useSelector((state) => state?.certifications?.details);

  const l = useInvertedLocalize(invertedMessages);

  const todoTabCount = tabData?.find(
    (tab) => tab.key === TAB_STATUS_TODO
  )?.count;
  const consultedTabCount = tabData?.find(
    (tab) => tab.key === TAB_STATUS_CONS
  )?.count;
  const hasZeroCountForItems = Boolean(
    todoTabCount === 0 && consultedTabCount === 0
  );

  const [config, setConfig] = useState();

  useEffect(() => {
    if (reviewAndSubmit) {
      setConfig({
        certifier: reviewAndSubmit?.primaryCertifier
          ? PRIMARY_CERTIFIER
          : SECONDARY_CERTIFIER,
        isCommentEnabled: reviewAndSubmit?.isCommentEnabled,
        certifierName: reviewAndSubmit?.primaryCertifierName,
        isComplete: hasZeroCountForItems
          ? REVIEW_AND_SUBMIT_COMPLETED
          : REVIEW_AND_SUBMIT_NOT_COMPLETED,
        withESignature: reviewAndSubmit?.withESignature
          ? REVIEW_AND_SUBMIT_SIGNATURE
          : REVIEW_AND_SUBMIT_COMMENT,
        step: firstStep ? REVIEW_AND_SUBMIT_STEP_1 : REVIEW_AND_SUBMIT_STEP_2,
      });
    }
  }, [todoTabCount, reviewAndSubmit, firstStep]);

  if (
    config?.certifier === SECONDARY_CERTIFIER &&
    SUBTITLE[config?.certifier]?.[config?.isComplete]?.[
      config?.withESignature
    ]?.[config?.step]
  ) {
    return certsFormattedMessage(
      l(
        SUBTITLE[config?.certifier]?.[config?.isComplete]?.[
          config?.withESignature
        ]?.[config?.step],
        {
          reviewinfo: `(${config?.certifierName})`,
          name: `(${config?.certifierName})`,
        }
      ),
      {
        reviewinfo: `(${config?.certifierName})`,
        name: `(${config?.certifierName})`,
      }
    );
  }

  if (
    hasZeroCountForItems &&
    config?.certifier === PRIMARY_CERTIFIER &&
    config?.withESignature === REVIEW_AND_SUBMIT_COMMENT &&
    !config?.isCommentEnabled
  ) {
    return '';
  }

  if (hasZeroCountForItems) {
    return SUBTITLE[config?.certifier]?.[config?.isComplete]?.[
      config?.withESignature
    ]?.[config?.step];
  }

  const tempMidText =
    todoTabCount === 0
      ? `${consultedTabCount} ${l('Consulted items that must be completed')}`
      : `${todoTabCount} ${l('To-Do items that you must complete')}`;

  if (
    SUBTITLE[config?.certifier]?.[config?.isComplete]?.[
      config?.withESignature
    ]?.[config?.step]
  ) {
    return certsFormattedMessage(
      l(
        SUBTITLE[config?.certifier]?.[config?.isComplete]?.[
          config?.withESignature
        ]?.[config?.step],
        {
          reviewinfo: tempMidText,
          name: tempMidText,
        }
      ),
      {
        reviewinfo: tempMidText,
        name: tempMidText,
      }
    );
  }
}

ReviewAndSubmitSubTitle.propTypes = { firstStep: PropTypes.bool.isRequired };

export default ReviewAndSubmitSubTitle;
